import { FrameRectangle } from '../frame-rectangle/FrameRectangle';
import styles from './DownlineSearchLoader.module.scss';

export const DownlineSearchLoader = () => (
  <div className={styles['downline-search-loader-container']}>
    <FrameRectangle
      className={styles['downline-search-loader-container-header']}
      width="120"
      height="21"
      borderRadius="8"
    />
    <div className={styles['downline-search-loader-container-card']}>
      <FrameRectangle width="212" height="42" />
      <FrameRectangle borderRadius="14" width="24" height="24" />
    </div>
  </div>
);
